/* eslint-disable no-undef */
/**
 * Created by Arison on 2019/7/9.
 */
import React from 'react'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import {
    Button,
    Divider,
    message,
    InputNumber,
    Row,
    Col,
    Avatar,
    Input,
} from 'antd'
import './RechargeHome.css'
import { changeTabIndex } from '../../redux/actions/action'
import { connect } from 'react-redux'
import { Modal, Toast } from 'antd-mobile'
import { fetchGet, fetchPost } from '../../utils/fetchRequest'
import { API } from '../../configs/api.config'
import { regExpConfig } from '../../configs/regexp.config'
import ic_open from '../../style/imgs/ic_card_open.png'
import ic_lock from '../../style/imgs/ic_card_lock.png'

/**
 * Created by Arison on 19:51.
 * 校园充值
 */

const { alert } = Modal

class RechargeHome extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            name: 'RechargeHome',
            amount: 0,
            otherMoneyDisplay: false,
            payInfo: '',
            payResult: '',
            params: '',
            moneyAll: 0,//总金额
            inputMoneyNum: '',//默认输入10元
            cardState: true,
            rateType: 0,
        }
    }

    componentDidMount() {
        this.getPayState()
    }

    getPayState = () => {
        const { userInfo } = this.props
        if (userInfo.userRole === 1) {//家长
            let stuId = '10097'
            if (this.props.userInfo.parent != null) {
                if (this.props.userInfo.parent.student != null) {
                    if (this.props.userInfo.parent.student.stuId != null) {
                        stuId = this.props.userInfo.parent.student.stuId
                    }
                }
            }
            Toast.loading('')
            fetchGet(API.GET_AMOUNTS, {
                studentId: stuId,
            }).then((response) => {
                Toast.hide()
                console.log('response:' + JSON.stringify(response))
                if (response.success) {
                    this.setState({
                        moneyAll: response.data.total,
                        cardState: response.data.cardState,
                        rateType: this.props.userInfo.parent.rateType,
                    })
                }

            }).catch((error) => {
                Toast.hide()
                console.log('error:' + JSON.stringify(error))
            })
        } else {
            let stuId = '10097'
            if (this.props.userInfo.parent != null) {
                if (this.props.userInfo.parent.student != null) {
                    if (this.props.userInfo.parent.student.stuId != null) {
                        stuId = this.props.userInfo.parent.student.stuId
                    }
                }
            }
            Toast.loading('')
            fetchGet(API.GET_AMOUNTS_TEACHER, {
                teacherId: this.props.userInfo.user.userFunId,
            }).then((response) => {
                Toast.hide()
                console.log('response:' + JSON.stringify(response))
                if (response.success) {
                    this.setState({
                        moneyAll: response.data.total,
                        cardState: response.data.cardState,
                        rateType: this.props.userInfo.teacher.rateType,
                    })
                }

            }).catch((error) => {
                Toast.hide()
                console.log('error:' + JSON.stringify(error))
            })
        }

    }

    onChange = (e) => {
        console.log('onChange()', e.target.value)
        let value = e.target.value
        this.setState({ inputMoneyNum: value })
    }

    render() {
        let stuName = '', stuPhoto = ''
        const { userInfo } = this.props
        if (userInfo.userRole === 1) {//家长
            if (this.props.userInfo.parent != null) {
                if (this.props.userInfo.parent.student != null) {
                    if (this.props.userInfo.parent.student.stuName != null) {
                        stuName = this.props.userInfo.parent.student.stuName
                    }
                    if (this.props.userInfo.parent.student.stuPhoto != null) {
                        stuPhoto = this.props.userInfo.parent.student.stuPhoto
                    }
                }
            }
        } else {
            if (this.props.userInfo.teacher != null) {
                if (this.props.userInfo.teacher.teacherName != null) {
                    stuName = this.props.userInfo.teacher.teacherName
                }
                if (this.props.userInfo.userAvatar != null) {
                    stuPhoto = this.props.userInfo.userAvatar
                }
            }
        }

        return <div className=" flex_column">
            <div className="flex_column_center bg_light_green">
                <div className=" flex_column_center padding_20">
                    {/*<img className="img-circle flex_row_center" style={{marginLeft: "10px"}}*/}
                    {/*src={"https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=4285611627,3487298056&fm=27&gp=0.jpg"}*/}
                    {/*width={80}*/}
                    {/*height={80}/>*/}
                    {stuPhoto ?
                        <img className="img-circle flex_row_center"
                            width={78}
                            style={{ marginLeft: '10px' }}
                            src={stuPhoto}
                        /> :
                        this.props.isSelect ?
                            <Avatar className={this.props.isSelect
                                ? 'border-radius-50-blue'
                                : 'border-radius-50'}
                                size={68} icon='user' /> :
                            <Avatar className={this.props.isSelect
                                ? 'border-radius-50-blue'
                                : 'border-radius-50'}
                                size={68} icon='user' />
                    }
                    <div className="text_white span_16 margin_top_5">{stuName}</div>
                    {this.state.moneyAll < 0 ? <div className="text_white span_19">余额: --元</div> :
                        <div className="text_white span_19">余额: {this.state.moneyAll}元</div>
                    }
                    <div style={{ width: '100vw', marginRight: '7rem' }}>
                        {this.state.cardState ?
                            <img
                                className="img_right"
                                onClick={this.onClickIcCard.bind(this, false)}
                                src={ic_open}
                                width={40}
                                height={40} /> : <img className="img_right"
                                    onClick={this.onClickIcCard.bind(this,
                                        true)} src={ic_lock} width={40}
                                    height={40} />
                        }
                    </div>
                </div>
            </div>
            <div
                className="flex_row  flex_center_vertical bg_light_green_transparent ">
                <div className="ant-btn-div item_flex_1 flex_center " onClick={() => {
                    // message.info("点击div")
                    this.props.changeTabIndex(1)//
                    this.props.history.push('/rechargePayList')
                }
                }>
                    <img src={require('imgs/pay_history.png')} width={22} />
                    <span className="span_16">充值记录</span>
                </div>
                <Divider type="vertical" />
                <div className="ant-btn-div item_flex_1 flex_center" onClick={() => {
                    this.props.changeTabIndex(0)//
                    this.props.history.push('/rechargePayList')
                }}>
                    <img src={require('imgs/pay_history.png')} width={22} />
                    <span className="span_16">消费记录</span></div>
                <Divider type="vertical" />
                <div className="ant-btn-div item_flex_1 item_center " onClick={() => {
                    this.props.history.push('/rechargeIntroduce')
                }}>
                    <img src={require('imgs/pay_introduce.png')} width={22} />
                    <div className="item_center span_16 ">使用说明</div>
                </div>
            </div>

            {this.state.rateType===0?
            (<div><div className="flex_column  padding_10">
                <div className="text_bold">充值金额</div>
                {this.state.otherMoneyDisplay == false ? (
                    <div>
                        {this.props.userInfo.user.schoolId === 36 ? '' :
                            <div className="flex  margin_top_10">
                                <Button className="item_flex_1" onClick={() => {
                                    this.wxPayRequest(10)
                                }}><span className="margin_10">10元</span></Button>
                                <Button className="item_flex_1 margin_left_10 " onClick={() => {
                                    this.wxPayRequest(20)
                                }}>20元</Button>
                            </div>
                        }
                        <div className="flex  margin_top_10">
                            <Button className="item_flex_1" onClick={() => {
                                this.wxPayRequest(50)
                            }}><span className="margin_10">50元</span></Button>
                            <Button className="item_flex_1 margin_left_10 " onClick={() => {
                                this.wxPayRequest(100)
                            }}>100元</Button>
                        </div>
                        <div className="flex margin_top_10">
                            <Button className="item_flex_1 " onClick={() => {
                                this.wxPayRequest(200)
                            }}>200元</Button>
                            <Button className="item_flex_1 margin_left_10 "
                                onClick={() => {
                                    this.setState({
                                        otherMoneyDisplay: true,
                                    })
                                }}>其它金额</Button>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className="flex margin_top_10">
                            <Input value={this.state.inputMoneyNum}
                                placeholder="请输入充值金额"
                                onChange={this.onChange} />
                        </div>
                        <div className="flex margin_top_10">
                            <Button className="item_flex_1 " onClick={() => {
                                if (regExpConfig.money.test(this.state.inputMoneyNum)) {
                                    this.wxPayRequest(this.state.inputMoneyNum)
                                } else {
                                    Toast.show('请输入正确的充值金额！')
                                }
                            }}>充值</Button>
                            <Button className="item_flex_1 margin_left_10 "
                                onClick={() => {
                                    this.setState({
                                        otherMoneyDisplay: false,
                                    })
                                }}>取消</Button>
                        </div>
                    </div>)}

            </div>

            <div className="div-long-text padding_10">
                <div className="span_15 text_bold">温馨提醒:</div>
                <div className="div-long-text margin_top_10">
                    充值成功后，请持校园卡消费时完成领款显示卡金额^_^
                </div>
            </div></div>)
            :
            (<div className="padding_101">
            <div className="service-content-item1">手续费<span>￥0.3%</span></div>
            <div className="div-long-text padding_10">
                <span className="span_15 text_bold">提示:</span>
                <span className="div-long-text margin_top_10">
                    手续费符合国家规定费率由微信及支付机构收取，平安校园和学校均未收取任何费用
                </span>
            </div>
            <div className="flex_column  padding_102">
                <div className="text_bold1">选择充值金额</div>

                <div>
                    <div className="flex  margin_top_10">
                        <Button className="item_flex_1" onClick={() => {
                            this.wxPayRequest1(10)
                        }}><span className="margin_10">10元</span></Button>
                        <Button className="item_flex_1 margin_left_10 " onClick={() => {
                            this.wxPayRequest1(20)
                        }}>20元</Button>
                    </div>
                    <div className="flex  margin_top_10">
                        <Button className="item_flex_1" onClick={() => {
                            this.wxPayRequest1(50)
                        }}><span className="margin_10">50元</span></Button>
                        <Button className="item_flex_1 margin_left_10 " onClick={() => {
                            this.wxPayRequest1(100)
                        }}>100元</Button>
                    </div>
                    <div className="flex margin_top_10">
                        <Button className="item_flex_1 " onClick={() => {
                            this.wxPayRequest1(200)
                        }}>200元</Button>
                        <Button className="item_flex_1 margin_left_10" onClick={() => {
                            this.wxPayRequest1(300)
                        }}>300元</Button>
                    </div>
                </div>

            </div>
            </div>)
            }

            {/* <div className="div-long-text">
                  {this.state.payInfo}
            </div>
            <div className="div-long-text">
                {this.state.payResult}
            </div>
            <div className="div-long-text">
                {this.props.userOpenid}
            </div>
            <div className="div-long-text">
                {this.state.params}
            </div>*/}

        </div>
    }

    onClickIcCard(f1) {
        const { userInfo } = this.props
        alert('', '确认挂失当前卡吗？挂失后卡片将无法进行消费', [
            {
                text: '取消', onPress: () => {
                },
            },
            {
                text: '确定', onPress: () => {
                    if (userInfo.userRole === 1) {//家长
                        let stuId = '10097'
                        if (this.props.userInfo.parent != null) {
                            if (this.props.userInfo.parent.student != null) {
                                if (this.props.userInfo.parent.student.stuId != null) {
                                    stuId = this.props.userInfo.parent.student.stuId
                                }
                            }
                        }
                        Toast.loading('')
                        fetchPost(API.STUDENTS_CARD_LOSE, {
                            stuId: stuId,
                        }).then((response) => {
                            Toast.hide()
                            console.log('response:' + JSON.stringify(response))
                            if (response.success) {
                                Toast.show(response.data)
                                this.setState({
                                    cardState: f1,
                                })
                            } else {
                                Toast.fail(response.message, 2)
                            }
                        }).catch((error) => {
                            Toast.hide()
                            console.log('error:' + JSON.stringify(error))
                        })
                    } else {
                        Toast.loading('')
                        fetchPost(API.TEACHER_CARD_LOSE, {
                            teacherId: this.props.userInfo.user.userFunId,
                        }).then((response) => {
                            Toast.hide()
                            console.log('response:' + JSON.stringify(response))
                            if (response.success) {
                                Toast.show(response.data)
                                this.setState({
                                    cardState: f1,
                                })
                            } else {
                                Toast.fail(response.message, 2)
                            }
                        }).catch((error) => {
                            Toast.hide()
                            console.log('error:' + JSON.stringify(error))
                        })
                    }
                },
            },
        ])
    }

    //  teacherId: this.props.userInfo.user.userFunId,
    wxPayRequest = (amount) => {
        this.state.amount = amount
        if (amount <= 0) {
            Toast.show('请输入正确的充值金额！')
            return
        }
        let err = ''
        const { userInfo } = this.props
        if (userInfo.userRole === 1) {//家长
            Toast.loading('')
            let openId = ''
            let stuId = '10097'
            let parentId = '76'
            if (typeof this.props.userOpenid == 'undefined' ||
                this.props.userOpenid == null || this.props.userOpenid == '') {
                openId = 'o8lZ9uGnn074M2wiP_5cWsZ3NL8s'
            } else {
                openId = this.props.userOpenid
            }
            if (this.props.userInfo.parent != null) {
                if (this.props.userInfo.parent.student != null) {
                    if (this.props.userInfo.parent.student.stuId != null) {
                        stuId = this.props.userInfo.parent.student.stuId
                    }
                }
            }
            if (this.props.userInfo.parent != null) {
                if (this.props.userInfo.parent.parentId != null) {
                    parentId = this.props.userInfo.parent.parentId
                }

            }
            fetchPost(API.PAY_ACTION, {
                openId: openId,
                amount: amount,
                studentId: this.props.userInfo.parent.student.stuId, //this.props.userInfo.parent.student.stuId
                parentId: this.props.userInfo.parent.parentId,   //this.props.userInfo.parent.parentId
            }).then((response) => {
                Toast.hide()
                const data = response.data
                err = data
                if (err === undefined) {
                    err = response.message;
                }
                if (typeof WeixinJSBridge == 'undefined') {
                    if (document.addEventListener) {
                        document.addEventListener('WeixinJSBridgeReady',
                            this.onBridgeReady(data), false)
                    } else if (document.attachEvent) {
                        document.attachEvent('WeixinJSBridgeReady',
                            this.onBridgeReady(data))
                        document.attachEvent('onWeixinJSBridgeReady',
                            this.onBridgeReady(data))
                    }
                } else {
                    this.onBridgeReady(data)
                }
            }).catch((error) => {
                console.log('error:' + JSON.stringify(error))
                if (this.props.userInfo.user.schoolId === 20) {
                    Toast.show(<div style={{ alignItems: 'center' }}><div>线上充值免费试用期已过，由于您卡内服务费余额不足，当前功能无法继续正常使用，如想继续享用服务，请阅读同意话费预存服务条款。</div><Button type="primary" block
                        style={{ marginTop: '10px', letterSpacing: '10px', background: '#05DC40', borderRadius: '30px', fontSize: '14px', border: 'none', margin: '10px 10px 10px 10px' }}
                        onClick={this.payPayable}>话费预存</Button></div>, 0, 'fa-circle-o-notch fa-spin', false);
                    const timer = setTimeout(() => {
                        Toast.hide();
                        clearTimeout(timer);
                    }, 8000);
                }
                // Toast.show('支付失败！')
                if (error === '由于您未成功缴纳智慧校园信息服务费，当前功能无法在线开放！') {
                    //this.props.history.push('/rechargeInfoService')
                    Toast.show(<div style={{ alignItems: 'center' }}><div>线上充值免费试用期已过，由于您未缴纳平安校园信息服务费，当前功能无法继续正常使用，如想继续享用服务，请补缴费。</div><Button type="primary" block
                        style={{ marginTop: '10px', letterSpacing: '10px', background: '#05DC40', borderRadius: '30px', fontSize: '14px', border: 'none', margin: '10px 10px 10px 10px' }}
                        onClick={this.payCost}>现在缴费</Button></div>, 0, 'fa-circle-o-notch fa-spin', false);
                    const timer = setTimeout(() => {
                        Toast.hide();
                        clearTimeout(timer);
                    }, 8000);
                } else if (error === '由于您卡内服务费余额不足，当前功能无法在线开放！') {
                    Toast.show(<div style={{ alignItems: 'center' }}><div>线上充值免费试用期已过，由于您卡内服务费余额不足，当前功能无法继续正常使用，如想继续享用服务，请阅读同意话费预存服务条款。</div><Button type="primary" block
                        style={{ marginTop: '10px', letterSpacing: '10px', background: '#05DC40', borderRadius: '30px', fontSize: '14px', border: 'none', margin: '10px 10px 10px 10px' }}
                        onClick={this.payPayable}>话费预存</Button></div>, 0, 'fa-circle-o-notch fa-spin', false);
                    const timer = setTimeout(() => {
                        Toast.hide();
                        clearTimeout(timer);
                    }, 8000);
                }else {
                    Toast.show(error)
                }
            })
        } else {
            Toast.loading('')
            let openId = ''
            if (typeof this.props.userOpenid == 'undefined' ||
                this.props.userOpenid == null || this.props.userOpenid == '') {
                openId = 'o8lZ9uGnn074M2wiP_5cWsZ3NL8s'
            } else {
                openId = this.props.userOpenid
            }
            fetchPost(API.PAY_ACTION_TEACHER, {
                openId: openId,
                amount: amount,
                teacherId: this.props.userInfo.user.userFunId,
            }).then((response) => {
                Toast.hide()
                const data = response.data
                err = data
                if (err === undefined) {
                    err = response.message;
                }
                if (typeof WeixinJSBridge == 'undefined') {
                    if (document.addEventListener) {
                        document.addEventListener('WeixinJSBridgeReady',
                            this.onBridgeReady(data), false)
                    } else if (document.attachEvent) {
                        document.attachEvent('WeixinJSBridgeReady',
                            this.onBridgeReady(data))
                        document.attachEvent('onWeixinJSBridgeReady',
                            this.onBridgeReady(data))
                    }
                } else {
                    this.onBridgeReady(data)
                }
            }).catch((error) => {
                console.log('error:' + JSON.stringify(error))
                // Toast.show('支付失败！' )
                Toast.show(error)
            })
        }

    }

    wxPayRequest1 = (amount) => {
        let money = amount+amount * 0.003
        this.state.amount = money
        let err = ''
        const { userInfo } = this.props
        if (userInfo.userRole === 1) {//家长
            Toast.loading('')
            let openId = ''
            let stuId = '10097'
            let parentId = '76'
            if (typeof this.props.userOpenid == 'undefined' ||
                this.props.userOpenid == null || this.props.userOpenid == '') {
                openId = 'o8lZ9uGnn074M2wiP_5cWsZ3NL8s'
            } else {
                openId = this.props.userOpenid
            }
            if (this.props.userInfo.parent != null) {
                if (this.props.userInfo.parent.student != null) {
                    if (this.props.userInfo.parent.student.stuId != null) {
                        stuId = this.props.userInfo.parent.student.stuId
                    }
                }
            }
            if (this.props.userInfo.parent != null) {
                if (this.props.userInfo.parent.parentId != null) {
                    parentId = this.props.userInfo.parent.parentId
                }

            }
            fetchPost(API.PAY_ACTION, {
                openId: openId,
                amount: money,
                studentId: this.props.userInfo.parent.student.stuId, //this.props.userInfo.parent.student.stuId
                parentId: this.props.userInfo.parent.parentId,   //this.props.userInfo.parent.parentId
            }).then((response) => {
                Toast.hide()
                const data = response.data
                err = data
                if (err === undefined) {
                    err = response.message;
                }
                if (typeof WeixinJSBridge == 'undefined') {
                    if (document.addEventListener) {
                        document.addEventListener('WeixinJSBridgeReady',
                            this.onBridgeReady(data), false)
                    } else if (document.attachEvent) {
                        document.attachEvent('WeixinJSBridgeReady',
                            this.onBridgeReady(data))
                        document.attachEvent('onWeixinJSBridgeReady',
                            this.onBridgeReady(data))
                    }
                } else {
                    this.onBridgeReady(data)
                }
            }).catch((error) => {
                console.log('error:' + JSON.stringify(error))
                if (this.props.userInfo.user.schoolId === 20) {
                    Toast.show(<div style={{ alignItems: 'center' }}><div>线上充值免费试用期已过，由于您卡内服务费余额不足，当前功能无法继续正常使用，如想继续享用服务，请阅读同意话费预存服务条款。</div><Button type="primary" block
                        style={{ marginTop: '10px', letterSpacing: '10px', background: '#05DC40', borderRadius: '30px', fontSize: '14px', border: 'none', margin: '10px 10px 10px 10px' }}
                        onClick={this.payPayable}>话费预存</Button></div>, 0, 'fa-circle-o-notch fa-spin', false);
                    const timer = setTimeout(() => {
                        Toast.hide();
                        clearTimeout(timer);
                    }, 8000);
                }
                // Toast.show('支付失败！')
                if (error === '由于您未成功缴纳智慧校园信息服务费，当前功能无法在线开放！') {
                    //this.props.history.push('/rechargeInfoService')
                    Toast.show(<div style={{ alignItems: 'center' }}><div>线上充值免费试用期已过，由于您未缴纳平安校园信息服务费，当前功能无法继续正常使用，如想继续享用服务，请补缴费。</div><Button type="primary" block
                        style={{ marginTop: '10px', letterSpacing: '10px', background: '#05DC40', borderRadius: '30px', fontSize: '14px', border: 'none', margin: '10px 10px 10px 10px' }}
                        onClick={this.payCost}>现在缴费</Button></div>, 0, 'fa-circle-o-notch fa-spin', false);
                    const timer = setTimeout(() => {
                        Toast.hide();
                        clearTimeout(timer);
                    }, 8000);
                } else if (error === '由于您卡内服务费余额不足，当前功能无法在线开放！') {
                    Toast.show(<div style={{ alignItems: 'center' }}><div>线上充值免费试用期已过，由于您卡内服务费余额不足，当前功能无法继续正常使用，如想继续享用服务，请阅读同意话费预存服务条款。</div><Button type="primary" block
                        style={{ marginTop: '10px', letterSpacing: '10px', background: '#05DC40', borderRadius: '30px', fontSize: '14px', border: 'none', margin: '10px 10px 10px 10px' }}
                        onClick={this.payPayable}>话费预存</Button></div>, 0, 'fa-circle-o-notch fa-spin', false);
                    const timer = setTimeout(() => {
                        Toast.hide();
                        clearTimeout(timer);
                    }, 8000);
                }else {
                    Toast.show(error)
                }
            })
        } else {
            Toast.loading('')
            let openId = ''
            if (typeof this.props.userOpenid == 'undefined' ||
                this.props.userOpenid == null || this.props.userOpenid == '') {
                openId = 'o8lZ9uGnn074M2wiP_5cWsZ3NL8s'
            } else {
                openId = this.props.userOpenid
            }
            fetchPost(API.PAY_ACTION_TEACHER, {
                openId: openId,
                amount: money,
                teacherId: this.props.userInfo.user.userFunId,
            }).then((response) => {
                Toast.hide()
                const data = response.data
                err = data
                if (err === undefined) {
                    err = response.message;
                }
                if (typeof WeixinJSBridge == 'undefined') {
                    if (document.addEventListener) {
                        document.addEventListener('WeixinJSBridgeReady',
                            this.onBridgeReady(data), false)
                    } else if (document.attachEvent) {
                        document.attachEvent('WeixinJSBridgeReady',
                            this.onBridgeReady(data))
                        document.attachEvent('onWeixinJSBridgeReady',
                            this.onBridgeReady(data))
                    }
                } else {
                    this.onBridgeReady(data)
                }
            }).catch((error) => {
                console.log('error:' + JSON.stringify(error))
                // Toast.show('支付失败！' )
                Toast.show(error)
            })
        }

    }

    payCost = () => {
        this.props.history.push('/rechargeInfoService')
    }

    payPayable = () => {
        this.props.history.push('/payableCost')
    }

    onBridgeReady = (json) => {
        console.log('json:', json)
        const that = this
        WeixinJSBridge.invoke(
            'getBrandWCPayRequest', JSON.parse(json),
            function (res) {
                if (res.err_msg == 'get_brand_wcpay_request:ok') {
                    // 使用以上方式判断前端返回,微信团队郑重提示：
                    //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                    //Toast.success("支付成功！")
                    that.props.history.push('/payResult/' + that.state.amount)
                } else {
                    Toast.fail('支付失败！')
                    // message.info("支付失败:" + res.err_msg)
                    // that.setState({
                    //     payInfo: json,
                    //     payResult: "支付失败:" + JSON.stringify(res)
                    // });
                }
            })
    }

}

const mapStateToProps = state => ({
    tabIndex: state.appState.tabIndex,
    userOpenid: state.redUserInfo.userOpenid,
    userInfo: { ...state.redUserInfo },
})

const mapDispatchToProps = dispatch => ({
    changeTabIndex: (tabIndex) => {
        dispatch(changeTabIndex(tabIndex))
    },
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(RechargeHome)
